export const COLOR = {
  PRIMARY: {
    100: '#E6E3FC',
    200: '#D1CCF9',
    300: '#b6acf5',
    400: '#a18bee',
    500: '#926fe5',
    DEFAULT: '#926fe5',
    600: '#8553d8',
    700: '#7344BE',
    800: '#5d399a',
  },
  SECONDARY: {
    100: '#D6FFEC',
    200: '#B0FFDA',
    300: '#74FFBE',
    400: '#30F89A',
    500: '#05D172',
    DEFAULT: '#05D172',
    600: '#00BC63',
    700: '#029350',
    800: '#087343',
  },
  TERTIARY: {
    100: '#fce8e4',
    200: '#fad6ce',
    300: '#f5b9ac',
    400: '#ea816a',
    500: '#E16C52',
    DEFAULT: '#e16c52',
    600: '#cd5035',
  },
  WHITE_APP: '#FAF9FB',
  BLACK_APP: '#231838',
  GRAY_APP: {
    100: '#f0eff0',
    200: '#e3e2e3',
    300: '#d0cfd2',
    400: '#bdbbbe',
    500: '#b0aeb2',
    DEFAULT: '#b0aeb2',
    600: '#969398',
    700: '#817f83',
    800: '#6a686b',
  },
  DETAIL: '#F3F1FE',
  STEPPER_TITTLE: '#191919',
  STEPPER_SUB: '#636363',
  DISABLED: '#E7E7EA',
  WARNING: {
    DEFAULT: '#E8B931',
    SECONDARY: '#FFF1C2',
  },
};
